import { render, staticRenderFns } from "./GliEditorTextField.vue?vue&type=template&id=58163a13"
import script from "./GliEditorTextField.vue?vue&type=script&lang=js"
export * from "./GliEditorTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports